import { useEffect } from "react"
import { initClarity } from "../utils/clarity.ts"
import { useGetConfig } from "../api/config/get.ts"

export function useClarity() {
    const { data } = useGetConfig()

    useEffect(() => {
        if (import.meta.env.MODE === 'production' && data?.CLARITY_ID) {
            initClarity(data.CLARITY_ID)
        }
    }, [data?.CLARITY_ID])
}
